export default {"src":"/_next/static/media/icon_ticketz.f37c7123.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};